import { z } from 'zod';
import superjson from 'superjson';
import { UserRole } from '../../helpers/schema';

export const schema = z.object({
  displayName: z.string().min(1, 'Display name cannot be empty').optional(),
  avatarUrl: z.string().url('Invalid URL').nullable().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  id: number;
  email: string;
  displayName: string;
  avatarUrl: string | null;
  role: UserRole;
  createdAt: Date;
};

export const postUserProfile = async (
  body: z.infer<typeof schema>,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/user/profile`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
